import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-24",
  "use": "icon-sheet_icon-24-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-24\"><g transform=\"translate(1 3)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\".75\" y=\".75\" width=\"20.5\" height=\"16.5\" rx=\"2\" /><path stroke-linecap=\"round\" d=\"M3.997 7.182h5\" /><circle cx=\"15.5\" cy=\"6.5\" r=\"1.75\" /><path stroke-linecap=\"round\" d=\"M4 12.5h10\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol